import { render } from "./SystemView.vue?vue&type=template&id=d0a65472"
import script from "./SystemView.vue?vue&type=script&lang=js"
export * from "./SystemView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__